<script setup lang="ts">
import Sidebar from '@/global/Sidebar.vue';

import '../styles/main.scss';
</script>

<template>
  <Sidebar />
  <main class="main">
    <RouterView />
  </main>
</template>
